import {
  QueryKey,
  UseMutationResult,
  UseQueryResult,
  useMutation,
  useQuery,
} from '@tanstack/react-query';
import { DeletedPatient } from 'PracticeDeletedPatientsTypes';
import { getQueryUrl, jsonFetch } from 'utils/react-query';

export const practiceDeletedPatientsBaseQueryKey: QueryKey = ['practice', 'deleted-patients'];

const queryKeys = {
  getPracticeDeletedPatients: (params?: { limit?: number }): QueryKey => [
    'practice',
    'deleted-patients',
    ...(params ? [params] : []),
  ],
};

export function usePracticeDeletedPatients(params?: {
  limit?: number;
}): UseQueryResult<DeletedPatient[]> {
  return useQuery({
    queryKey: queryKeys.getPracticeDeletedPatients(params),
  });
}

export function useRestoreDeletedPatient(): UseMutationResult<
  { message: string },
  unknown,
  { patientId: number },
  unknown
> {
  return useMutation({
    mutationFn: ({ patientId }: { patientId: number }) => {
      return jsonFetch<{ message: string }>(getQueryUrl(['activity-logs', patientId, 'undelete']), {
        method: 'POST',
      });
    },
  });
}

export function useUnmergePatient(): UseMutationResult<
  { message: string },
  unknown,
  { patientId: number },
  unknown
> {
  return useMutation({
    mutationFn: ({ patientId }: { patientId: number }) => {
      return jsonFetch<{ message: string }>(getQueryUrl(['activity-logs', patientId, 'unmerge']), {
        method: 'POST',
      });
    },
  });
}
